<ngx-spinner
  style="z-index: 1000000 !important;"
  [fullScreen]="fullScreen"
  bdColor="{{bgColor}}"
  [size]="size"
  color="{{color}}"
  type="{{type}}">
  <p class="text">{{LOADING_TEXT}}</p>
</ngx-spinner>
